import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Award, ExternalLink } from 'lucide-react';

const certifications = [
  {
    name: 'AWS Certified Solutions Architect',
    level: 'Associate',
    year: '2024',
    issuer: 'Amazon Web Services',
    color: 'cloud'
  },
  {
    name: 'AWS Certified SysOps Administrator',
    level: 'Associate',
    year: '2023',
    issuer: 'Amazon Web Services',
    color: 'cloud'
  },
  {
    name: 'Cisco Certified Network Associate',
    level: 'CCNA Security',
    year: '2018',
    issuer: 'Cisco',
    color: 'network'
  },
  {
    name: 'Microsoft Certified Solutions Expert',
    level: 'MCSE',
    year: '2018',
    issuer: 'Microsoft',
    color: 'server'
  },
  {
    name: 'VMware Certified Professional',
    level: 'VCP',
    year: '2017',
    issuer: 'VMware',
    color: 'infra'
  }
];

export const CertificationsSection = () => {
  return (
    <section id="certifications" className="py-20 md:py-28 bg-secondary/30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Certifications
          </h2>
          <div className="w-20 h-1 bg-primary mx-auto rounded-full mb-6" />
          <p className="text-muted-foreground max-w-2xl mx-auto text-base sm:text-lg">
            Industry-recognized certifications demonstrating expertise in cloud, 
            networking, and systems administration.
          </p>
        </div>

        {/* Certifications Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {certifications.map((cert, index) => (
            <Card 
              key={index} 
              className="group bg-card border-border hover:border-primary/30 cert-glow transition-all"
            >
              <CardContent className="p-6 flex flex-col h-full">
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 rounded-xl bg-primary-soft flex items-center justify-center group-hover:scale-110 transition-transform">
                    <Award className="w-6 h-6 text-primary" />
                  </div>
                  <Badge variant="outline" className="text-xs font-mono">
                    {cert.year}
                  </Badge>
                </div>
                
                <h3 className="font-heading font-semibold text-lg text-foreground mb-1">
                  {cert.name}
                </h3>
                <p className="text-primary font-medium text-sm mb-2">
                  {cert.level}
                </p>
                <p className="text-muted-foreground text-sm mt-auto">
                  {cert.issuer}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* LinkedIn CTA */}
        <div className="mt-10 text-center">
          <a 
            href="https://www.linkedin.com/in/narekonanyan" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-primary hover:text-primary/80 font-medium transition-colors link-underline"
          >
            View all credentials on LinkedIn
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
